import { Grid, Stack, styled } from '@mui/material';
import { WsColors, WsButton } from 'wisestep-base';

export const DrawerFooter = styled(Grid)(() => ({
  position: 'fixed',
  bottom: 1,
  justifyContent: 'revert',
  background: WsColors.TertiaryShades100,
  width: '50vw',
}));

const AdvanceFilterFooterBar = () => (
  <DrawerFooter>
    <Stack p={1} columnGap={2} direction="row" flexDirection="row-reverse">
      <WsButton variant="contained" size="large" type="submit">
        Apply
      </WsButton>
      <WsButton variant="outlined" size="large" type="reset">
        Reset
      </WsButton>
    </Stack>
  </DrawerFooter>
);
export default AdvanceFilterFooterBar;
